// src/utils/crmCustomers.js
export const createCrmCustomerPayload = (values, user) => {
  return {
     action: values.id || values.acc_id ? "update" : "create",
    acc_id: values.id || values.acc_id || 0,

    acc_name: values.acc_name,
    institution_name: values.institution_name || "",
    contact_no: values.contact_no || "",
    email_address: values.email_address || "",
    profession: values.profession || "",
    address: values.address || "",
    location_id: values.location_id || 0,
    conversation: values.conversation || "",
    expectation_per: values.expectation_per || 0,

    // defaults
    party_type: values.party_type || "retailer",
    status: values.status || "p",
    acc_type: {
      acc_type_name: "Customer",
      acc_type_id: "debitor",
      label: "Customer",
    },
    opening_balance: 0,
    country_code: values.country_code,
    employee_id: 0,
    credit_limit: 0,
    bank_acc_number: "",
    bank_acc_name: "",
    bank_branch: "",
    bank_acc_type: "",
    // audit fields
    created_by: user?.userInfo?.user_id,
    branch_id: user?.userInfo?.branch_id,
    institution_id: user?.userInfo?.pro_id,
  };
};
